'use client'

// src/wbk/AnimatedLogo.tsx
import { useEffect, useState } from "react";
import { jsx } from "react/jsx-runtime";
var LETTERS = [
  "M120.799 1.78037V114.07C120.799 115.061 120.009 115.852 119.021 115.852H74.1786C73.4873 115.852 72.8948 115.456 72.5985 114.962L61.93 96.4606C61.2387 95.2737 59.5599 95.2737 58.8686 96.5595L48.2014 114.962C47.9051 115.456 47.3126 115.852 46.72 115.852H1.87666C0.790193 115.852 0 115.061 0 114.07V1.78037C0 0.791277 0.790193 0 1.87666 0H24.1993C24.7919 0 25.3844 0.395638 25.6807 0.89678L34.669 16.5245L42.7684 30.3718C43.4597 31.6643 45.1386 31.6643 45.8299 30.3718L58.8686 7.82045C59.5599 6.63354 61.2387 6.63354 61.93 7.82045L74.9687 30.3718C75.66 31.6643 77.3389 31.6643 78.0302 30.3718L86.1296 16.5245L95.1179 0.89678C95.4142 0.395638 96.0067 0 96.698 0H119.021C120.009 0 120.799 0.791277 120.799 1.78037Z",
  "M107.462 50.1617L96.7867 56.2954C95.6006 56.9877 95.6006 58.7681 96.7867 59.4605L107.462 65.5942L119.916 72.8159C120.509 73.114 120.799 73.7074 120.799 74.3998V102.1C120.799 102.693 120.509 103.288 119.916 103.684L99.2512 115.555C98.9612 115.753 98.6581 115.852 98.3682 115.852H1.77917C0.79074 115.852 0 115.061 0 114.07V1.78037C0 0.791277 0.79074 0 1.77917 0H98.3682C98.6581 0 98.9612 0.105504 99.2512 0.303323L119.916 12.1725C120.509 12.4626 120.799 13.0561 120.799 13.6495V41.4497C120.799 42.0432 120.509 42.6366 119.916 42.9399L107.462 50.1617Z",
  "M104.286 48.2811L90.3553 56.3943C89.1692 56.9877 89.1692 58.7681 90.3553 59.4605L104.286 67.4748L119.903 76.5758C120.496 76.8725 120.799 77.466 120.799 78.0594V114.07C120.799 115.061 120.008 115.852 119.02 115.852H74.132C73.4467 115.852 72.8536 115.456 72.5505 114.962L66.7253 104.871L61.9809 96.5595C61.2824 95.2737 59.5033 95.2737 58.818 96.5595L48.2352 114.962C47.8398 115.456 47.2468 115.852 46.6537 115.852H1.77917C0.79074 115.852 0 115.061 0 114.07V1.78037C0 0.791277 0.79074 0 1.77917 0H46.6537C47.2468 0 47.8398 0.395638 48.2352 0.89678L58.818 19.294C59.5033 20.4809 61.2824 20.4809 61.9809 19.294L72.5505 0.89678C72.8536 0.395638 73.4467 0 74.132 0H119.02C120.008 0 120.799 0.791277 120.799 1.78037V37.6911C120.799 38.3901 120.496 38.9836 119.903 39.2737L104.286 48.2811Z"
];
var AnimatedWbkLogo = ({ className = "" }) => {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % LETTERS.length);
    }, 300);
    return () => clearInterval(interval);
  }, []);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "121",
      height: "116",
      viewBox: "0 0 121 116",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          opacity: 0.2,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: LETTERS[index],
          fill: "currentColor"
        }
      )
    }
  );
};

// src/wbk/AppIcon.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var WbkAppIcon = ({ className = "" }) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "140",
      height: "140",
      viewBox: "0 0 140 140",
      fill: "none",
      className,
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip0_65_40388)", children: [
          /* @__PURE__ */ jsx2(
            "path",
            {
              d: "M128 0H12C5.37258 0 0 5.37258 0 12V128C0 134.627 5.37258 140 12 140H128C134.627 140 140 134.627 140 128V12C140 5.37258 134.627 0 128 0Z",
              fill: "#F84878"
            }
          ),
          /* @__PURE__ */ jsx2(
            "mask",
            {
              id: "mask0_65_40388",
              style: { maskType: "luminance" },
              maskUnits: "userSpaceOnUse",
              x: "10",
              y: "51",
              width: "120",
              height: "38",
              children: /* @__PURE__ */ jsx2("path", { d: "M130 51H10V88.5H130V51Z", fill: "white" })
            }
          ),
          /* @__PURE__ */ jsx2("g", { mask: "url(#mask0_65_40388)", children: /* @__PURE__ */ jsx2(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M47.8235 86.7168V51.5575C47.8235 51.2478 47.5762 51 47.2669 51H40.2773C40.0608 51 39.8753 51.1239 39.7825 51.2808L36.9682 56.174L34.4322 60.5098C34.2157 60.9144 33.69 60.9144 33.4736 60.5098L29.391 53.4487C29.1746 53.077 28.6489 53.077 28.4324 53.4487L24.3499 60.5098C24.1334 60.9144 23.6077 60.9144 23.3913 60.5098L20.8553 56.174L18.0409 51.2808C17.9482 51.1239 17.7626 51 17.5771 51H10.5876C10.2474 51 10 51.2478 10 51.5575V86.7168C10 87.0269 10.2474 87.2746 10.5876 87.2746H24.6286C24.8141 87.2746 24.9996 87.1508 25.0924 86.9959L28.4324 81.2339C28.6489 80.8313 29.1746 80.8313 29.391 81.2029L32.7314 86.9959C32.8242 87.1508 33.0097 87.2746 33.2262 87.2746H47.2669C47.5762 87.2746 47.8235 87.0269 47.8235 86.7168ZM84.5605 66.7062L81.2181 68.6267C80.8467 68.8435 80.8467 69.401 81.2181 69.6178L84.5605 71.5383L88.4601 73.7995C88.6458 73.8928 88.7366 74.0786 88.7366 74.2954V82.9686C88.7366 83.1544 88.6458 83.3407 88.4601 83.4645L81.9897 87.1817C81.899 87.2437 81.804 87.2746 81.7133 87.2746H51.4701C51.1606 87.2746 50.913 87.0269 50.913 86.7168V51.5575C50.913 51.2478 51.1606 51 51.4701 51H81.7133C81.804 51 81.899 51.033 81.9897 51.095L88.4601 54.8113C88.6458 54.9022 88.7366 55.088 88.7366 55.2738V63.9784C88.7366 64.1642 88.6458 64.35 88.4601 64.445L84.5605 66.7062ZM124.831 66.1174L120.469 68.6577C120.098 68.8435 120.098 69.401 120.469 69.6178L124.831 72.1271L129.721 74.9768C129.906 75.0697 130.001 75.2555 130.001 75.4413V86.7168C130.001 87.0269 129.754 87.2746 129.444 87.2746H115.389C115.175 87.2746 114.989 87.1508 114.894 86.9959L113.07 83.8362L111.585 81.2339C111.366 80.8313 110.809 80.8313 110.594 81.2339L107.281 86.9959C107.157 87.1508 106.971 87.2746 106.785 87.2746H92.7347C92.4252 87.2746 92.1776 87.0269 92.1776 86.7168V51.5575C92.1776 51.2478 92.4252 51 92.7347 51H106.785C106.971 51 107.157 51.1239 107.281 51.2808L110.594 57.0412C110.809 57.4128 111.366 57.4128 111.585 57.0412L114.894 51.2808C114.989 51.1239 115.175 51 115.389 51H129.444C129.754 51 130.001 51.2478 130.001 51.5575V62.8015C130.001 63.0204 129.906 63.2062 129.721 63.2971L124.831 66.1174Z",
              fill: "white"
            }
          ) })
        ] }),
        /* @__PURE__ */ jsx2("defs", { children: /* @__PURE__ */ jsx2("clipPath", { id: "clip0_65_40388", children: /* @__PURE__ */ jsx2("rect", { width: "140", height: "140", fill: "white" }) }) })
      ]
    }
  );
};

// src/wbk/WbkLogo.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var WbkLogo = ({ className = "", width = 150, height = 46 }) => {
  return /* @__PURE__ */ jsx3(
    "svg",
    {
      width,
      height,
      viewBox: "0 0 150 46",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: /* @__PURE__ */ jsx3(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M47.0155 44.3619V0.696956H47.0183C47.0183 0.31158 46.7067 0 46.3213 0H37.6299C37.3812 0 37.1516 0.133925 37.0259 0.349845L33.5138 6.43386L30.3898 11.8483C30.122 12.3129 29.4496 12.3129 29.1818 11.8483L24.1145 3.07207C23.8467 2.60743 23.1743 2.60743 22.9065 3.07207L17.8392 11.851C17.5714 12.3156 16.899 12.3156 16.6312 11.851L13.5045 6.43386L9.99237 0.349845C9.86665 0.133925 9.63706 0 9.38835 0H0.696952C0.311578 0 0 0.31158 0 0.696956V44.3619C0 44.7473 0.311578 45.0589 0.696952 45.0589H18.1645C18.4132 45.0589 18.6428 44.925 18.7685 44.709L22.901 37.5427C23.1689 37.0781 23.8412 37.0781 24.1091 37.5427L28.2498 44.7118C28.3755 44.925 28.6051 45.0589 28.8538 45.0589H46.3186C46.704 45.0589 47.0155 44.7473 47.0155 44.3619ZM143.547 18.8041L138.141 21.9254C137.676 22.1933 137.676 22.8656 138.141 23.1335L143.547 26.2547L149.65 29.7778C149.866 29.9035 150 30.1331 150 30.3818V44.3592C150 44.7446 149.688 45.0562 149.303 45.0562H131.833C131.584 45.0562 131.355 44.9222 131.229 44.7063L128.96 40.776L127.094 37.5427C126.826 37.0781 126.153 37.0781 125.886 37.5427L121.748 44.709C121.622 44.925 121.392 45.0589 121.144 45.0589H103.676C103.291 45.0589 102.979 44.7473 102.979 44.3619V0.696956C102.979 0.31158 103.291 0 103.676 0H121.144C121.392 0 121.622 0.133925 121.748 0.349845L125.886 7.51619C126.153 7.98083 126.826 7.98083 127.094 7.51619L131.229 0.349845C131.355 0.133925 131.584 0 131.833 0H149.303C149.688 0 150 0.31158 150 0.696956V14.6771C150 14.9258 149.866 15.1554 149.65 15.2811L143.547 18.8041ZM93.303 19.5263L89.1513 21.9233C88.6867 22.1911 88.6867 22.8635 89.1513 23.1313L93.303 25.5283L98.1516 28.327C98.3675 28.4528 98.5014 28.6824 98.5014 28.9311V39.7106C98.5014 39.9594 98.3675 40.1889 98.1516 40.3147L90.1024 44.9638C89.9959 45.0239 89.8756 45.0567 89.7526 45.0567H52.1773C51.792 45.0567 51.4804 44.7451 51.4804 44.3597V0.697559C51.4804 0.312183 51.792 0.000603647 52.1773 0.000603647H89.7526C89.8756 0.000603647 89.9959 0.0334015 90.1024 0.093531L98.1516 4.74263C98.3675 4.86836 98.5014 5.09794 98.5014 5.34666V16.1262C98.5014 16.3749 98.3675 16.6045 98.1516 16.7303L93.303 19.529V19.5263Z",
          fill: "currentColor"
        }
      )
    }
  );
};

export {
  AnimatedWbkLogo,
  WbkAppIcon,
  WbkLogo
};
//# sourceMappingURL=chunk-ZOVM7HEK.mjs.map